export default __webpack_public_path__ + "static/media/7.0d3f4786.JPG";